import { NavLink} from 'react-router-dom';

export default function AdministrarCaracterizacion(){

    const secciones = [
        {
            title: 'Parámetros',
            links: [
                { href: '/parametros/ayudasxroles', label: 'Ayudas por roles' },
                { href: '/parametros/ayudasxentidades', label: 'Ayudas por entidades' },
                { href: '/parametros/permisosxroles', label: 'Permisos por roles' },
            ],
        },
        {
            title: 'Administrar personas y familias',
            links: [
                { href: '/parametros/administrarfamilia', label: 'Convertir integrante a Jefe de Hogar' },
                { href: '/parametros/pasarintegrantefamilia', label: 'Pasar integrante a otra familia' },
                { href: '/parametros/pasarjefehogarfamilia', label: 'Pasar Jefe Hogar a otra familia' },
                { href: '/parametros/eliminarpersona', label: 'Eliminar persona' },
            ],
        },
    ];

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Administraci&oacute;n caracterizaci&oacute;n</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item active"> Administarci&oacute;n caracterizaci&oacute;n</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {secciones.map((seccion) => (
                        <div className="row" key={seccion.title}>
                            <div className="col-md-12">
                                <div className="card card">
                                    <div className="card-header">
                                        <h3 className="card-title">{seccion.title}</h3>
                                    </div>
                                    <div className="card-body">
                                        <ul className="nav nav-treeview">
                                            {seccion.links.map((link) => (
                                                <li className="nav-item mr-2 mb-2" key={link.href}>
                                                    <a href={link.href} className="btn btn-outline-primary">
                                                        <span>{link.label}</span>
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}